/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { Domaine } from '@/types/Domaine';
import type { ProduitDomaine } from '@/types/ProduitDomaine';
import type { Produit } from '@/types/Produit';

type ProduitDomaineStoreType = {
  produitDomaine: ProduitDomaine;
  setProduitDomaine: (produitDomaine: ProduitDomaine) => void;
  produitDomaineEtcv: ProduitDomaine;
  setProduitDomaineEtcv: (produitDomaineEtcv: ProduitDomaine) => void;
  domaine: Domaine;
  setDomaine: (domaine: Domaine) => void;
  produit: Produit;
  setProduit: (produit: Produit) => void;
};

const useProduitDomaineStore = create<ProduitDomaineStoreType>()(
  devtools((set) => ({
    produitDomaine: null,
    setProduitDomaine: (produitDomaine) => set({ produitDomaine }),
    produitDomaineEtcv: null,
    setProduitDomaineEtcv: (produitDomaineEtcv) => set({ produitDomaineEtcv }),
    domaine: null,
    setDomaine: (domaine) => set({ domaine }),
    produit: null,
    setProduit: (produit) => set({ produit }),
  })),
);

export default useProduitDomaineStore;
